export const IMAGE_SELECTOR_STATUSES = {
	UPLOADING: 'uploading',
	ERROR: 'error',
	COMPLETE: 'complete',
};
